import { render, staticRenderFns } from "./InvestigadorEmail.vue?vue&type=template&id=75b8a6b0&"
import script from "./InvestigadorEmail.vue?vue&type=script&lang=js&"
export * from "./InvestigadorEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports